import React, {useReducer, useEffect} from 'react'
import axios from 'axios'

const initialState = {
  loading: true,
  errors: [],

  error: '',

  reportTitle: "Dashboard Stats",

  referrals: -1,
  clients: -1,
  postdischarges: -1,

  postdischarges90d: -1,
  postdischarges180d: -1,
  postdischarges12m: -1,
  postdischarges24m: -1,
  postdischarges36m: -1,

  archivedreferrals: -1,
  archivedclients: -1,
  archivedpostdischarges: -1,    
}

const reducer = (state, action) => {
     switch(action.type) {
         case 'FETCH_SUCCESS':
          var dataEntry;

          var referrals = -1;
          var clients = -1;
          var postdischarges = -1;
          
          var postdischarges90d = -1;
          var postdischarges180d = -1;
          var postdischarges12m = -1;
          var postdischarges24m = -1;
          var postdischarges36m = -1;
      
          var archivedreferrals = -1;
          var archivedclients = -1;
          var archivedpostdischarges = -1;
  
          console.log("4447-10011 - action.payload.data = " );
          console.log( action.payload.data);
  
          dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data[0] : [] ;
          if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {                        
            console.log("4447-10012 - dataEntry = " );
            console.log( dataEntry);
            // console.log( dataEntry[0]);

              referrals = dataEntry.referrals;
              clients = dataEntry.clients;
              postdischarges = dataEntry.postdischarges;
              
              postdischarges = dataEntry.postdischarges;
              postdischarges90d = dataEntry.postdischarges90d;
              postdischarges180d = dataEntry.postdischarges180d;
              postdischarges12m = dataEntry.postdischarges12m;
              postdischarges24m = dataEntry.postdischarges24m;
              postdischarges36m = dataEntry.postdischarges36m;
      
              archivedreferrals = dataEntry.archivedreferrals;
              archivedclients = dataEntry.archivedclients;
              archivedpostdischarges = dataEntry.archivedpostdischarges;
          }
          return {
            loading: false,
            error: '',
        
            reportTitle: "Dashboard Stats",

            referrals: referrals,
            clients: clients,
            postdischarges: postdischarges,
            
            postdischarges90d: postdischarges90d,
            postdischarges180d: postdischarges180d,
            postdischarges12m: postdischarges12m,
            postdischarges24m: postdischarges24m,
            postdischarges36m: postdischarges36m,
    
            archivedreferrals: archivedreferrals,
            archivedclients: archivedclients,
            archivedpostdischarges: archivedpostdischarges,

          }
         case 'FETCH_ERROR':
            return {
              loading: false,
              error: 'ERROR: DashboardCounts - Something went wrong.....',
              // errors: [action.payload.response],

        
              referrals: -1,
              clients: -1,
              postdischarges: -1,
              
              postdischarges90d: -1,
              postdischarges180d: -1,
              postdischarges12m: -1,
              postdischarges24m: -1,
              postdischarges36m: -1,
      
              archivedreferrals: -1,
              archivedclients: -1,
              archivedpostdischarges: -1,

            }
        default:
            return state
     }
}

function DashboardCounts() {
    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
      // const  DASHBOARD_COUNTS = 'reports/dashboardcounts/loginid'
      const  DASHBOARD_COUNTS_2 = 'reports/dashboardcounts2'

        // const postURL = `https://jsonplaceholder.typicode.com/posts/1`
        const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + DASHBOARD_COUNTS_2
        axios
            // .get(postURL)
            .get(JSONURL)
            .then(response => {
                dispatch({type: 'FETCH_SUCCESS', payload: response.data})
            })
            .catch(err => {
                dispatch({type: 'FETCH_ERROR'})
            })

        // return () => {
        //     cleanup
        // };
    }, [])

    return (
      <div>            

        <p class="reporttitle">{state.loading ? 'Loading...' : state.reportTitle}</p>

        <table>
          
          <thead>
            <tr>
              <th class="bodyheader">SERVICE</th>
              {/* <th class="service">SERVICE</th> */}
              <th class="desc">DESCRIPTION</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="bodydata">Referrals</td>
              <td class="bodydata">{state.referrals}</td>
            </tr>
            <tr>
              <td class="service">Clients</td>
              <td class="bodydata">{state.clients}</td>
            </tr>
            <tr>
              <td class="service">Post Discharges</td>
              <td class="bodydata">{state.postdischarges}</td>
            </tr>



            <tr>
              <td class="service">Post Discharges 90 Days</td>
              <td class="bodydata">{state.postdischarges90d}</td>
            </tr>
            <tr>
              <td class="service">Post Discharges 180 Days</td>
              <td class="bodydata">{state.postdischarges180d}</td>
            </tr>
            <tr>
              <td class="service">Post Discharges 12 Months</td>
              <td class="bodydata">{state.postdischarges12m}</td>
            </tr>
            <tr>
              <td class="service">Post Discharges 24 Months</td>
              <td class="bodydata">{state.postdischarges24m}</td>
            </tr>
            <tr>
              <td class="service">Post Discharges 36 Months</td>
              <td class="bodydata">{state.postdischarges36m}</td>
            </tr>



            <tr>
              <td class="bodydata">Archived Referrals</td>
              <td class="bodydata">{state.archivedreferrals}</td>
            </tr>
            <tr>
              <td class="service">Archived Clients</td>
              <td class="bodydata">{state.archivedclients}</td>
            </tr>
            <tr>
              <td class="service">Archived Post Discharges</td>
              <td class="bodydata">{state.archivedpostdischarges}</td>
            </tr>


            {/* Totals */}
            <tr>
              <td colspan="0">SUBTOTAL</td>
              <td class="total">$5,200.00</td>
            </tr>
            <tr>
              <td colspan="0">TAX 25%</td>
              <td class="total">$1,300.00</td>
            </tr>
            <tr>
              <td colspan="0" class="grand total">GRAND TOTAL</td>
              <td class="grand total">$6,500.00</td>
            </tr>

  {/*           
            <tr>
              <td colspan="3">SUBTOTAL</td>
              <td class="total">$5,200.00</td>
            </tr>
            <tr>
              <td colspan="3">TAX 25%</td>
              <td class="total">$1,300.00</td>
            </tr>
            <tr>
              <td colspan="3" class="grand total">GRAND TOTAL</td>
              <td class="grand total">$6,500.00</td>
            </tr>
  */}

            
          </tbody>
        </table>

        <hr />
        {state.error ? state.error : null}

      </div>
    )
}
export default DashboardCounts
